module.exports = __webpack_public_path__ + "img/37.1973d6d4.png";